import { NgModule } from "@angular/core";
import { StoreModule } from '@ngrx/store';
import * as fromFeatureFlags from './reducers';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    StoreModule.forFeature(
      fromFeatureFlags.featureFlagsKey,
      fromFeatureFlags.reducers
    )
  ]
})
export class FeatureFlagModule { }